import { DataGrid, GridColDef, useGridApiRef } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import { gridClasses } from '@mui/x-data-grid';
import { Box, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openReportAPIRefSliceAction } from '../../../../../app/Slices/ReportAPIRefSlice';
import CustomNoRowsOverlay from '../../../../shared/NoRowsOverlayCustom';

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    '& .MuiTablePagination-toolbar': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignContent: 'center',
    },
    '& .MuiTablePagination-displayedRows ': {
        paddingTop: '14px',
    },
    '& .MuiTablePagination-selectLabel': {
        paddingTop: '14px',
    },
    '& .MuiTablePagination-select': {
        paddingTop: '4px',
    },

    '& .MuiDataGrid-columnHeader': {
        fontSize: '12px',
        fontWeight: 900,
        color: '#000',
        borderBottom: `1px solid ${theme.palette.midGrey.main}`,
    },
    [`& .${gridClasses.row}`]: {
        '&:hover, &.Mui-hovered': {
            backgroundColor: 'none',
            color: theme.palette.textAccent.main,

            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.neutral.main,

            color: theme.palette.textAccent.main,
            '&:hover, &.Mui-hovered': {
                backgroundColor: 'none',
                color: theme.palette.textAccent.main,

                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'none',
                },
            },
        },
    },
}));

export default function GuestCountListReport(params: any) {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const apiRef = useGridApiRef();
    const dispatch = useDispatch();

    useEffect(() => {
        const csv = apiRef?.current.exportDataAsCsv;
        const print = apiRef?.current.exportDataAsPrint;
        dispatch(
            openReportAPIRefSliceAction({
                exportInfo: {
                    csvExport: csv,
                    printExport: print,
                    search: apiRef?.current.setQuickFilterValues,
                },
            }),
        );
    }, [apiRef]);

    const columns: GridColDef[] = [
        {
            field: 'name',
            headerName: 'Company',
            flex: 1,
            minWidth: isIpad ? 200 : 200,
            type: 'string',
            sortable: true,
            renderCell: (params) => {
                return params?.value;
            },
        },
        {
            field: 'activeUsers',
            headerName: 'Active User Count',
            width: isMobile ? 140 : isIpad ? 140 : 140,
            type: '',
            sortable: true,
            renderCell: (params) => {
                return params?.value;
            },
        },
    ];

    return (
        <Box
            sx={{
                height: 'auto',
                width: isMobile ? '90vw' : '100%',
                paddingTop: '50px',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    overflowX: 'auto',
                }}
            >
                <StripedDataGrid
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                            ? 'even'
                            : 'odd'
                    }
                    sx={{
                        boxShadow: 0,
                        border: 0,
                    }}
                    apiRef={apiRef}
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    rows={params?.data !== undefined ? params?.data : []}
                    columns={columns}
                    slots={{
                        noRowsOverlay: CustomNoRowsOverlay,
                    }}
                />
            </Box>{' '}
        </Box>
    );
}
